import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLogAppAction } from 'hooks/useLogAppAction';

/**
 * Logs a `page_view:<pathname>` app action on every route change. Mounted
 * once near the app root (App.tsx, alongside <ScrollToTop />) so every
 * current and future route is covered automatically — no per-page wiring.
 */
export const AppActionLogger = (): any => {
  const { pathname } = useLocation();
  const logAppAction = useLogAppAction();

  useEffect(() => {
    logAppAction(`page_view:${pathname}`);
  }, [pathname]);

  return null;
};

export default AppActionLogger;
